import * as React from "react";

export const FooterContext = React.createContext({
  hasFooter: false,
  setHasFooter: function () {} as React.Dispatch<React.SetStateAction<boolean>>
});

FooterContext.displayName = "FooterContext";

export function FooterContextProvider(props) {
  const [hasFooter, setHasFooter] = React.useState(false);

  return (
    <FooterContext.Provider
      value={{
        hasFooter,
        setHasFooter
      }}
    >
      {props.children}
    </FooterContext.Provider>
  );
}
